export const AgentOfficeApiFields = {
	clientId: {
		name: "clientId",
		displayName: "Client ID",
		beName: "client_id",
	},
	clientSecret: {
		name: "clientSecret",
		displayName: "Client Secret",
		beName: "client_secret",
	},
};
